import { Headline } from 'components/Headline';
import { TabType, Tabs } from 'components/Tabs';

import * as S from './Manage.styles';

type ManageProps = {
  title: string;
  tabs: TabType[];
  isNew?: boolean;
};

export function Manage({ title, tabs }: ManageProps): React.ReactElement {
  return (
    <S.Container>
      <S.Header>
        <Headline fontWeight="bold" fontFamily="LFT Zeno Condensed" scale="xl" color="black">
          {title}
        </Headline>
      </S.Header>

      <S.TabsWrapper>
        <Tabs saveUser={() => {}} tabs={tabs} />
      </S.TabsWrapper>
    </S.Container>
  );
}
